<template>
  <MarketResearch
    :entity-id="entityId"
    :source="entitySource"
    :is-quick-action="true"
    :is-pending="isPending"
  />
</template>

<script setup>
import { computed } from "vue";
import MarketResearch from "@/src/components/activity_components/MarketResearch.vue";
import { entityViews } from "@/src/constants/pageConstants.js";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";

const props = defineProps({
  row: { type: Object, required: true },
  source: { type: String, required: true },
  pendingIds: { type: Array, required: true },
});

const entityId = computed(() => props.row?.id);

const entitySource = computed(() => {
  if (props.source === entityTypes.CONTACT) {
    return entityViews.CONTACT_VIEW;
  } else if (props.source === entityTypes.COMPANY) {
    return entityViews.COMPANY_VIEW;
  } else if (props.source === entityTypes.LEAD) {
    return entityViews.LEAD_VIEW;
  }
});

const isPending = computed(() => {
  const rowId = props.row?.id;
  if (rowId == null) return false;
  return props.pendingIds.some((id) => String(id) === String(rowId));
});
</script>
